export enum StepType {
  // UNDEFINED = 'UNDEFINED',
  // VIDEO = 'VIDEO',
  // IMAGE = 'IMAGE',
  SESSION = 'SESSION',
  FORM = 'FORM',
  INSTRUCTION = "INSTRUCTION",
  // Driver's Component — Rest / Stop / Swap and the "I'm Driving" control
  // handover. Replaces the old process-level Transaction Controls.
  DRIVER = 'DRIVER',
  // Redirect — sends the user to another assigned transaction they pick at
  // runtime (list / QR / manual). Config lives in component.settings.redirect.
  REDIRECT = 'REDIRECT',
  // CHECKLIST = 'CHECKLIST',
  // ESIGN = 'ESIGN',
  // LOCATION removed — location tracking is now a process-level setting
  // (Teams → Location Tracking tab), not a workflow step.
  // LOCATION = 'LOCATION',
  // DOCUMENT = 'DOCUMENT',
  // REVIEW = 'REVIEW',
  // AUTO = 'AUTO'
}

export enum InputComponents {
  TEXT = 'TEXT',
  NUMBER = 'NUMBER',
  FILE = 'FILE',
  // PASSWORD = 'PASSWORD',
  SELECT = 'SELECT',
  DROPDOWN = 'DROPDOWN',
  
  CHECKBOX = 'CHECKBOX',
  RADIO = 'RADIO',
  CAMERA = 'CAMERA',
  // FORM = 'FORM',
  DATE = 'DATE',
  ESIGN = 'ESIGN',
  // TEXTARRAY = 'TEXTARRAY',
  SWITCH = 'SWITCH'
}
